import { startMockingNetworkWithHar } from 'frontend-container/mockNetworkWithHar/setupWorkers';

import { fetchAcConfig } from '@ac/library-utils/dist/utils/ac-config';

const startApplication = async () => {
  await fetchAcConfig();

  const { defineGlobalProperties } = await import('./indexForPublicComponents');
  defineGlobalProperties();

  if (process.env.NODE_ENV === 'development' && process.env.HAR_FILES) {
    await startMockingNetworkWithHar();
  }

  const { startApp } = await import('./startApplication');
  await startApp();
};

startApplication();

export {};
